var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Reproductor',{attrs:{"msg":"Lección #1","audio2":"../mp3/SecundariaB/01SB.mp3","cover":"../img/9.jpg","name":"Secundaria B"}}),_c('Buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }